import http from '../../http-common-admin';
import httpCandidatures from '../../http-common-candidatures';


class FacultyService {

    getAll(universityID){
        return http.get(`/faculties?universityID=${universityID}`);
    }

    getAllCandidature(universityID){
        return httpCandidatures.get(`/faculties?universityID=${universityID}`);
    }

    getAllLogin(tipoDisplay,  role, universityID){
        return http.get(`/faculties?tipoDisplay=${tipoDisplay}&role=${role}&universityID=${universityID}`);
    }
    getAllForConfigOnly(tipoDisplay, universityID){
        return http.get(`/faculties?tipoDisplay=${tipoDisplay}&universityID=${universityID}`);
    }

    getAllLoginCandatures(tipoDisplay){
        return httpCandidatures.get(`/faculties?tipoDisplay=${tipoDisplay}`);
    }

    getAllByID(universityID, tipoDisplay){
        return http.get(`/faculties?universityID=${universityID}&tipoDisplay=${tipoDisplay}`);
    }
    

    getAlliDB(tipoDisplay, professurID, year, facultyID, departID, turnoID, academicyearID, turmaID, studentMatriculaID){

        return http.get(`/faculties?tipoDisplay=${tipoDisplay}&professurID=${professurID}&year=${year}&facultyID=${facultyID}&departID=${departID}&turnoID=${turnoID}&academicyearID=${academicyearID}&turmaID=${turmaID}&studentMatriculaID=${studentMatriculaID}`);
    }

    getAlliDBPorTurma(tipoDisplay, universityID, year){

        return http.get(`/faculties?tipoDisplay=${tipoDisplay}&universityID=${universityID}&year=${year} `);
    }

    
    create(data){
        return  http.post("/faculties", data);
    }

    getcode(id, tipoPedido, dadoPesquisa, universityID){
        return http.get(`/faculties/${id}?tipoPedido=${tipoPedido}&dadoPesquisa=${dadoPesquisa}&universityID=${universityID}`)
    }
    // Search faculties ID

    getID(id){
        return http.get(`/faculties/${id}`)
    }
    update(id, data){
        return http.put(`/faculties/${id}`, data)
    }

    updateCalendario(id, data){
        return http.put(`/faculties/updateCalendario/${id}`, data)
    }

    updateAvaliationType(id, data){
        return http.put(`/faculties/updateavaliationtype/${id}`, data)
    }
    
    // delete faculties

    delete(id){
        return http.delete(`/faculties/${id}`)
    }
}

export default new FacultyService();